import type { ModalNameType, ModalPayload } from '@/modals/components/ModalProvider';
import { MODAL_DATA_PARAM, MODAL_PARAM } from '../consts';

type OpenModalOptions = {
  history?: 'push' | 'replace';
};

type OpenModalArguments<TName extends ModalNameType>
  = ModalPayload<TName> extends void
    ? [modalData?: undefined, options?: OpenModalOptions]
    : undefined extends ModalPayload<TName>
      ? [modalData?: Exclude<ModalPayload<TName>, undefined>, options?: OpenModalOptions]
      : [modalData: ModalPayload<TName>, options?: OpenModalOptions];

const getModalUrl = (
  modalName: ModalNameType,
  modalData: unknown,
): string => {
  const params = new URLSearchParams();
  params.set(MODAL_PARAM, modalName);
  if (modalData != null) {
    params.set(MODAL_DATA_PARAM, JSON.stringify(modalData));
  }
  return `?${params.toString()}`;
};

function openModal<TName extends ModalNameType>(
  modalName: TName,
  ...args: OpenModalArguments<TName>
): void;
function openModal(
  modalName: ModalNameType,
  modalData?: unknown,
  options?: OpenModalOptions,
): void {
  const url = getModalUrl(modalName, modalData);

  if (options?.history === 'replace') {
    window.history.replaceState({}, '', url);
    return;
  }

  window.history.pushState({}, '', url);
}

export default openModal;
